(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dreamlover-review-questionnaire"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dreamlover-review-questionnaire')) {
    customElements.define('dreamlover-review-questionnaire', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.status = this.querySelector('[data-dl-status]');
        this.pendingProfile = '';
        this.bypassNativeButton = false;
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onNativeSubmit = this.handleNativeSubmit.bind(this);
        document.addEventListener('click', this.onDocumentClick, true);
        document.addEventListener('submit', this.onNativeSubmit, true);

        this.querySelectorAll('[data-dl-option]').forEach((button) => button.addEventListener('click', () => this.toggleOption(button)));
        this.querySelector('[data-dl-close]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-dl-next]')?.addEventListener('click', () => this.showStep('needs'));
        this.querySelector('[data-dl-back]')?.addEventListener('click', () => this.showStep('profile'));
        this.querySelector('[data-dl-skip]')?.addEventListener('click', () => this.continueToNative(true));
        this.querySelector('[data-dl-finish]')?.addEventListener('click', () => this.continueToNative(false));
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });

        this.widgetObserver = new MutationObserver(() => {
          this.enhanceReviewWidget();
          this.decorateReviews();
          this.showProfileSummaryInNativeForm();
        });
        this.widgetObserver.observe(document.documentElement, { childList: true, subtree: true });
        this.enhanceReviewWidget();
        this.decorateReviews();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick, true);
        document.removeEventListener('submit', this.onNativeSubmit, true);
        this.widgetObserver?.disconnect();
      }

      findNativeWriteButton() {
        return [...document.querySelectorAll('#judgeme_product_reviews button, #judgeme_product_reviews [role="button"], .jdgm-review-widget button, .jdgm-review-widget [role="button"]')]
          .find((button) => /write\s+a\s+review/i.test(button.textContent || ''));
      }

      isJudgeMeElement(element) {
        return Boolean(element?.closest?.('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-review-widget-modal, .jdgm-write-review-modal, .jm-review-form, .jdgm-form-wrapper, [class*="jm-review-form"], [class*="jdgm-form"]'));
      }

      handleDocumentClick(event) {
        const button = event.target.closest?.('button, [role="button"]');
        if (!button || !this.isJudgeMeElement(button)) return;

        if (/write\s+a\s+review/i.test(button.textContent || '')) {
          if (this.bypassNativeButton) {
            this.bypassNativeButton = false;
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open();
          return;
        }

        if (this.isNativeSubmitButton(button)) this.prependProfileToReview();
      }

      isNativeSubmitButton(button) {
        return /submit|post|publish/i.test(button.textContent || '') && this.isJudgeMeElement(button);
      }

      handleNativeSubmit(event) {
        if (this.isJudgeMeElement(event.target)) this.prependProfileToReview();
      }

      open() {
        this.reset();
        this.dialog?.showModal();
      }

      close() { this.dialog?.close(); }

      reset() {
        this.showStep('profile');
        this.querySelectorAll('[data-dl-option]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        const other = this.querySelector('[data-dl-other]');
        if (other) other.value = '';
      }

      showStep(name) {
        this.querySelectorAll('[data-dl-step]').forEach((step) => {
          const active = step.dataset.dlStep === name;
          step.hidden = !active;
        });
      }

      toggleOption(button) {
        const group = button.closest('[data-dl-group]');
        const next = button.getAttribute('aria-pressed') !== 'true';
        if (group?.dataset.dlMode === 'single') group.querySelectorAll('[data-dl-option]').forEach((option) => option.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', String(next));
      }

      selected(groupName) {
        return [...this.querySelectorAll(`[data-dl-group="${groupName}"] [data-dl-option][aria-pressed="true"]`)].map((button) => button.value);
      }

      buildProfile() {
        const age = this.selected('age')[0];
        const worn = this.selected('worn');
        const matters = this.selected('matters');
        const other = this.querySelector('[data-dl-other]')?.value.trim();
        const lines = [];
        if (age && age !== 'Prefer not to say') lines.push(`Age range: ${age}`);
        if (worn.length) lines.push(`How it’s worn: ${worn.join(', ')}`);
        if (matters.length) lines.push(`What matters most: ${matters.join(', ')}`);
        if (other) lines.push(`Something else: ${other}`);
        return lines.length ? `[DL_PROFILE]\n${lines.join('\n')}\n[/DL_PROFILE]\n\n` : '';
      }

      continueToNative(skip) {
        this.pendingProfile = skip ? '' : this.buildProfile();
        this.close();
        const nativeButton = this.findNativeWriteButton();
        if (!nativeButton) {
          this.status.textContent = 'The review form is still loading. Please try again in a moment.';
          return;
        }
        this.bypassNativeButton = true;
        nativeButton.click();
        requestAnimationFrame(() => this.showProfileSummaryInNativeForm());
      }

      findReviewTextarea() {
        const candidates = [...document.querySelectorAll('#judgeme_product_reviews textarea, .jdgm-review-widget textarea, .jdgm-review-widget-modal textarea, .jdgm-write-review-modal textarea, .jm-review-form textarea, .jdgm-form-wrapper textarea, [class*="jm-review-form"] textarea, [class*="jdgm-form"] textarea')];
        return candidates.find((textarea) => /review|body|content/i.test(`${textarea.name} ${textarea.id} ${textarea.placeholder}`)) || candidates[0];
      }

      showProfileSummaryInNativeForm() {
        if (!this.pendingProfile) return;
        const textarea = this.findReviewTextarea();
        if (!textarea || textarea.dataset.dlProfileReady) return;
        textarea.dataset.dlProfileReady = 'true';
        textarea.placeholder = 'Tell us how the grip felt, fit, and supported your routine.';
        const details = this.parseProfile(this.pendingProfile);
        const summary = document.createElement('div');
        summary.className = 'dl-review-form-summary';
        summary.innerHTML = `<strong>Your optional details</strong>${details.map((item) => `<span>${this.escapeHtml(item.label)}: ${this.escapeHtml(item.value)}</span>`).join('<br>')}`;
        textarea.parentElement?.insertBefore(summary, textarea);
      }

      prependProfileToReview() {
        if (!this.pendingProfile) return;
        const textarea = this.findReviewTextarea();
        if (!textarea || !textarea.value.trim() || textarea.value.includes('[DL_PROFILE]')) return;
        textarea.value = `${this.pendingProfile}${textarea.value.trim()}`;
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
        textarea.dispatchEvent(new Event('change', { bubbles: true }));
        this.pendingProfile = '';
      }

      parseProfile(text) {
        const match = text.match(/\[DL_PROFILE\]([\s\S]*?)\[\/DL_PROFILE\]/);
        if (!match) return [];
        return match[1].trim().split(/\r?\n/).map((line) => {
          const separator = line.indexOf(':');
          return separator > -1 ? { label: line.slice(0, separator).trim(), value: line.slice(separator + 1).trim() } : null;
        }).filter(Boolean);
      }

      decorateReviews() {
        document.querySelectorAll('#judgeme_product_reviews .jm-review-content__body, #judgeme_product_reviews .jdgm-rev__body').forEach((body) => {
          if (body.dataset.dlDecorated) return;
          const text = body.textContent || '';
          const details = this.parseProfile(text);
          if (!details.length) return;
          const cleanBody = text.replace(/\[DL_PROFILE\][\s\S]*?\[\/DL_PROFILE\]\s*/, '').trim();
          const tags = document.createElement('div');
          tags.className = 'dl-review-profile';
          details.forEach((item) => {
            const tag = document.createElement('span');
            tag.className = 'dl-review-profile__tag';
            tag.textContent = `${item.label}: ${item.value}`;
            tags.appendChild(tag);
          });
          body.textContent = cleanBody;
          body.parentElement?.insertBefore(tags, body);
          body.dataset.dlDecorated = 'true';
        });
      }

      enhanceReviewWidget() {
        const root = document.querySelector('#judgeme_product_reviews');
        const widget = root?.querySelector('.jm-review-widget') || root?.firstElementChild;
        if (!root || !widget || widget.querySelector('.dl-live-reviews__intro')) return;

        root.classList.add('dl-live-reviews');
        const nativeHeader = widget.querySelector('.jm-review-widget__header');
        if (!nativeHeader) return;

        const ratingText = nativeHeader.querySelector('.jm-average-rating-display--minimal-header .jm-text:first-of-type')?.textContent || '';
        const countText = nativeHeader.querySelector('.jm-average-rating-display--minimal-header .jm-text:last-of-type')?.textContent || '';
        const rating = Number.parseFloat(ratingText) || 0;
        const total = Number.parseInt(countText.replace(/[^0-9]/g, ''), 10) || widget.querySelectorAll('.jm-review-item').length;
        const items = [...widget.querySelectorAll('.jm-review-item')];
        const distribution = [0, 0, 0, 0, 0];
        items.forEach((item) => {
          const score = this.reviewScore(item);
          if (score >= 1 && score <= 5) distribution[score - 1] += 1;
        });
        const completeDistribution = total > 0 && total <= items.length && distribution.reduce((sum, value) => sum + value, 0) >= total;
        const rows = [5, 4, 3, 2, 1].map((score) => {
          const count = completeDistribution ? distribution[score - 1] : null;
          const width = count === null || total === 0 ? 0 : Math.round((count / total) * 100);
          return `<div class="dl-live-reviews__bar"><span>${score} ★</span><i><b style="width:${width}%"></b></i><em>${count === null ? '—' : count}</em></div>`;
        }).join('');

        const intro = document.createElement('header');
        intro.className = 'dl-live-reviews__intro';
        intro.innerHTML = `<div><p>DREAMLOVER COMMUNITY</p><h2>Real comfort, shared honestly.</h2><span>Helpful details from people who wear Dreamlover in everyday life.</span></div><aside>CUSTOMER REVIEWS<small>${total} ${total === 1 ? 'verified experience' : 'verified experiences'}</small></aside>`;

        const summary = document.createElement('section');
        summary.className = 'dl-live-reviews__summary';
        summary.setAttribute('aria-label', 'Review summary');
        summary.innerHTML = `<div class="dl-live-reviews__score"><strong>${rating ? rating.toFixed(1) : '—'}</strong><div><span aria-label="${rating || 0} out of 5">${rating ? '★★★★★' : '☆☆☆☆☆'}</span><p>Based on ${total} ${total === 1 ? 'review' : 'reviews'}</p></div></div><div class="dl-live-reviews__bars">${rows}</div><div class="dl-live-reviews__recommend"><strong>—</strong><p>would recommend this product</p><small>Recommendation data is not available yet</small></div>`;

        const toolbar = document.createElement('div');
        toolbar.className = 'dl-live-reviews__toolbar';
        toolbar.innerHTML = `<div class="dl-live-reviews__tabs" role="tablist"><button type="button" class="is-active" role="tab" aria-selected="true" data-dl-live-tab="reviews">Reviews (${total})</button><button type="button" role="tab" aria-selected="false" data-dl-live-tab="questions">Questions (0)</button></div><button type="button" class="dl-live-reviews__write" data-dl-live-write>✎ <span>Write a review</span></button>`;

        const controls = document.createElement('div');
        controls.className = 'dl-live-reviews__controls';
        controls.innerHTML = `<div class="dl-live-reviews__filters"><span>FILTER BY</span><button type="button" class="is-active" data-dl-live-filter="all">All</button><button type="button" data-dl-live-filter="rating">Rating</button><button type="button" data-dl-live-filter="verified">Verified buyers</button><button type="button" data-dl-live-filter="photos">With photos</button><button type="button" data-dl-live-filter="worn">How it’s worn</button></div><label class="dl-live-reviews__sort"><span>SORT</span><select data-dl-live-sort aria-label="Sort reviews"><option value="helpful">Most helpful</option><option value="newest">Newest</option><option value="highest">Highest rated</option><option value="lowest">Lowest rated</option></select></label>`;

        const questionPanel = document.createElement('div');
        questionPanel.className = 'dl-live-reviews__questions';
        questionPanel.hidden = true;
        questionPanel.innerHTML = '<p>QUESTIONS & ANSWERS</p><h3>No questions yet.</h3><span>Helpful product answers will appear here when questions are enabled.</span>';

        const emptyPanel = document.createElement('div');
        emptyPanel.className = 'dl-live-reviews__empty';
        emptyPanel.hidden = total > 0;
        emptyPanel.innerHTML = '<p>YOUR EXPERIENCE CAN HELP</p><h3>Be the first to share your experience.</h3><span>Tell other shoppers how your Dreamlover grip feels and how you wear it.</span>';

        const insertParent = nativeHeader.parentElement;
        if (!insertParent) return;
        insertParent.insertBefore(intro, nativeHeader);
        insertParent.insertBefore(summary, nativeHeader);
        insertParent.insertBefore(toolbar, nativeHeader);
        insertParent.insertBefore(controls, nativeHeader);
        insertParent.insertBefore(emptyPanel, nativeHeader);
        insertParent.appendChild(questionPanel);
        nativeHeader.classList.add('dl-live-reviews__native-header');
        this.bindLiveReviewActions(widget, nativeHeader);
      }

      reviewScore(item) {
        const labelled = item.querySelector('[aria-label*="star" i], [title*="star" i]');
        const labelledValue = `${labelled?.getAttribute('aria-label') || ''} ${labelled?.getAttribute('title') || ''}`.match(/[1-5](?:\.0)?/);
        if (labelledValue) return Math.round(Number.parseFloat(labelledValue[0]));
        const filled = item.querySelectorAll('.jdgm-star.jdgm--on, .jm-star-rating__font-icon--filled, [class*="star"][class*="filled"]').length;
        return Math.min(5, filled);
      }

      bindLiveReviewActions(widget, nativeHeader) {
        widget.querySelector('[data-dl-live-write]')?.addEventListener('click', () => this.findNativeWriteButton()?.click());

        widget.querySelectorAll('[data-dl-live-tab]').forEach((button) => button.addEventListener('click', () => {
          const questions = button.dataset.dlLiveTab === 'questions';
          widget.querySelectorAll('[data-dl-live-tab]').forEach((tab) => {
            const active = tab === button;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          const body = widget.querySelector('.jm-review-widget__body');
          const questionPanel = widget.querySelector('.dl-live-reviews__questions');
          if (body) body.hidden = questions;
          if (questionPanel) questionPanel.hidden = !questions;
        }));

        widget.querySelectorAll('[data-dl-live-filter]').forEach((button) => button.addEventListener('click', () => {
          const filter = button.dataset.dlLiveFilter;
          widget.querySelectorAll('[data-dl-live-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
          const nativeFilter = nativeHeader.querySelector('[aria-label*="filter" i], [title*="filter" i], .jm-filter, .jm-filters-button');
          if (filter === 'rating' && nativeFilter) {
            nativeFilter.click();
            return;
          }
          widget.querySelectorAll('.jm-review-item').forEach((item) => {
            const text = item.textContent || '';
            const visible = filter === 'all'
              || (filter === 'verified' && /verified/i.test(text))
              || (filter === 'photos' && Boolean(item.querySelector('img, video')))
              || (filter === 'worn' && /how it.?s worn:/i.test(text));
            item.hidden = !visible;
          });
        }));

        widget.querySelector('[data-dl-live-sort]')?.addEventListener('change', (event) => {
          const nativeSort = nativeHeader.querySelector('select.jdgm-sort-dropdown, select');
          if (!nativeSort) return;
          const patterns = { helpful: /helpful/i, newest: /new|recent/i, highest: /high/i, lowest: /low/i };
          const option = [...nativeSort.options].find((item) => patterns[event.target.value]?.test(item.textContent || ''));
          if (!option) return;
          nativeSort.value = option.value;
          nativeSort.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      escapeHtml(value) {
        const node = document.createElement('div');
        node.textContent = value;
        return node.innerHTML;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dreamlover-reviews-preview"] && !Shopify.designMode) return;
  try {
    
  class DreamloverReviewPreview extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-review-dialog]');
      this.openButton = this.querySelector('[data-review-dialog-open]');
      this.openButton?.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-review-dialog-close]').forEach((button) => button.addEventListener('click', () => this.close()));
      this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
      this.querySelectorAll('[data-preview-filter]').forEach((button) => button.addEventListener('click', () => { const active = button.classList.toggle('is-active'); button.setAttribute('aria-pressed', String(active)); }));
      this.querySelectorAll('[data-review-tab]').forEach((button) => button.addEventListener('click', () => this.showTab(button.dataset.reviewTab)));
      this.querySelectorAll('[data-rating]').forEach((button) => button.addEventListener('click', () => this.setRating(Number(button.dataset.rating))));
      this.querySelectorAll('[data-choice]').forEach((button) => button.addEventListener('click', () => {
        const group = button.closest('[data-choice-mode]');
        if (group?.dataset.choiceMode === 'single') group.querySelectorAll('[data-choice]').forEach((option) => option.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
      }));
      this.querySelector('[data-form-next]')?.addEventListener('click', () => this.showStep('questions'));
      this.querySelector('[data-form-back]')?.addEventListener('click', () => this.showStep('rating'));
      this.querySelectorAll('[data-helpful]').forEach((button) => button.addEventListener('click', () => { const active = button.getAttribute('aria-pressed') === 'true'; button.setAttribute('aria-pressed', String(!active)); button.firstChild.textContent = active ? '♡ Helpful ' : '♥ Helpful '; const count = button.querySelector('span'); count.textContent = String(Number(count.textContent) + (active ? -1 : 1)); }));
    }
    open() { if (this.dialog?.showModal) this.dialog.showModal(); else this.dialog?.setAttribute('open',''); document.documentElement.style.overflow='hidden'; }
    close() { if (this.dialog?.close) this.dialog.close(); else this.dialog?.removeAttribute('open'); document.documentElement.style.removeProperty('overflow'); this.openButton?.focus(); }
    showTab(name) { this.querySelectorAll('[data-review-tab]').forEach((button) => button.setAttribute('aria-selected', String(button.dataset.reviewTab === name))); this.querySelectorAll('[data-review-panel]').forEach((panel) => panel.hidden = panel.dataset.reviewPanel !== name); }
    showStep(name) { this.querySelectorAll('[data-form-step]').forEach((step) => { const active=step.dataset.formStep===name; step.hidden=!active; step.classList.toggle('is-active',active); }); }
    setRating(value) { this.querySelectorAll('[data-rating]').forEach((button) => { const active=Number(button.dataset.rating)<=value; button.textContent=active?'★':'☆'; button.setAttribute('aria-pressed',String(Number(button.dataset.rating)===value)); }); this.querySelector('[data-form-next]').disabled=false; }
  }
  if (!customElements.get('dreamlover-review-preview')) customElements.define('dreamlover-review-preview', DreamloverReviewPreview);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
